// ABOUTME: Mounts the page-override runtime for every route so admin edits show up for all users.
// ABOUTME: Stands down while the live editor is open, since the editor previews its own drafts.

import { usePageOverrides } from '@/hooks/usePageOverrides';
import { useLiveEditor } from '@/contexts/LiveEditorContext';

export const PageOverridesApplier = () => {
  const { editing } = useLiveEditor();
  usePageOverrides(!editing);
  return null;
};
